// Auto24 market-price estimate via the details.autospy.ee proxy. Backed by a
// scrape upstream, so this is the slow one (~20 s typical, 2 min timeout).

import { detailsApiToken } from './http';
import { sanitizeRegistration } from './checkVehicle';
import { secureFetchJson } from '../security/secureFetch';

export interface Auto24PriceResponse {
  average_price?: string | null; // e.g. "12 000 kuni 15 000 €"
}

export async function fetchAuto24Price(
  plate: string,
  options: { signal?: AbortSignal } = {},
): Promise<Auto24PriceResponse> {
  return secureFetchJson<Auto24PriceResponse>('/auto24-price', {
    query: { regnr: sanitizeRegistration(plate) },
    signal: options.signal,
    timeoutMs: 120_000,
    label: 'Auto24 price',
    legacyToken: detailsApiToken(),
  });
}
